






















































import { Component, Vue, Prop } from 'vue-property-decorator'
import InputGeneric from '@/components/InputGeneric.vue'
import BaoCaoCell from '@/components/BaoCaoCell.vue'
import slugify from 'slugify'
import {
  patchCompanyGradeReport,
  patchCompanyManagerGradeReport,
  patchCompanyRepresentativeReport,
  patchInvestmentStatusReport,
} from '@/utils/ApiServices'
import { handle } from '@/utils/ErrorHandling'

type Value = string | number | null
type ReportData = Record<string, Value>

@Component({
  components: {
    InputGeneric,
    BaoCaoCell,
  }
})
export default class BaoCaoGeneric extends Vue {
  @Prop(Array) readonly reportsData!: Array<ReportData>
  @Prop(String) readonly reportType!: string
  @Prop(Object) readonly headerMapper!: Record<string, string>
  @Prop(Object) readonly formatMapper!: Record<string, string>
  @Prop(Object) readonly choicesMapper!: Record<string, string>

  get keys (): Array<string> {
    return Object.keys(this.headerMapper)
  }

  slugify (val: string) {
    val = val.toLowerCase().replaceAll('đ', 'd').replaceAll('&', '')
    return slugify(val)
  }

  overrideReport (index: number, format: string, row: ReportData, key: string, value: Value) {
    if (typeof value === 'string') {
      if (format === 'number' || format === 'money') {
        value = parseInt(value)
      }
      else if (format === 'percentage') {
        value = parseFloat(value)
      }
    }

    const id = row.id
    const data = { [key]: value }

    this.overrideMethod(id, data)
      .then(() => {
        const updatedRow = Object.assign(row, data)
        this.$set(this.reportsData, index, updatedRow)
        this.$store.dispatch('alertMessage', 'Cập nhật thành công.')
      })
      .catch(handle)
  }

  get overrideMethod () {
    const mapper: { [index: string]: CallableFunction } = {
      BaoCaoTinhHinhDauTu: patchInvestmentStatusReport,
      BaoCaoXepLoaiDN: patchCompanyGradeReport,
      BaoCaoXepLoaiNQLDN: patchCompanyManagerGradeReport,
      BaoCaoPLDGNDD: patchCompanyRepresentativeReport,
    }
    return mapper[this.reportType]
  }
}
